import React, { useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import "./QuestionbankCM.css";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import axios from "../../axios";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import ThreeDotPopup from "./ThreeDotPopup";
import { Popup } from "semantic-ui-react";
import DeleteConfirmationPopup from "./DeleteConfirmationPopup";
import ChangeNamePopup from "./ChangeNamePopup";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import QuestionPopup from "../../Components/QuestionPopup";
import { Alert, Button } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";

import {
  BookOpen,
  BookText,
  CalendarDays,
  ClipboardList,
  Lightbulb,
} from "lucide-react";
import { Tooltip } from "@mui/material";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import FilterBox from "../../Homework/pages/On_going/Published_Assessment/Filter_Box/FilterBox";
// PublishedThreeDotPopup

export default function QuestionbankCM({ type, activeHeader, checkLocalData }) {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON =
    JSON.parse(general_role) === null ? [] : JSON.parse(general_role);
  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON =
    JSON.parse(classTeacher) === null ? [] : JSON.parse(classTeacher);
  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON =
    JSON.parse(cordinator) === null ? [] : JSON.parse(cordinator);
  let TeacherIdLC = JSON.parse(localStorage.getItem("Teacher_id"));
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const navigate = useNavigate();
  function convertDateTime(inputString) {
    const inputDate = new Date(inputString);
    const optionsDate = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };
    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = inputDate
      .toLocaleDateString("en-GB", optionsDate)
      .replace(/\//g, "/");
    const formattedTime = inputDate.toLocaleTimeString("en-US", optionsTime);
    return `${formattedDate}`;
  }

  const [quesData, setQuesData] = useState([]);
  const [b4sQuesData, setB4sQuesData] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [choosedDate, setChoosedDate] = useState([]);
  const [isGettingData, setIsGettingData] = useState(false);
  const [isGettingB4SData, setIsGettingB4SData] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [openRenameQuestionBankNamePopup, setOpenRenameQuestionBankNamePopup] =
    useState(false);
  const [
    openDeleteQuestionBankConfirmationPopup,
    setOpenDeleteQuestionBankConfirmationPopup,
  ] = useState(false);
  const [isProcessLoading, setIsProcessLoading] = useState(false);
  const [book, setBook] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [bookAndChapter, setBookAndChapter] = useState([]);
  const skills = useSelector((state) => state.initialData.skills);
  const difficultyLevel = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const skillsData = useSelector((state) => state.initialData);
  const [TeacherId, setTeacherId] = useState(TeacherIdLC);
  const [deleteQuestionBankData, setDeleteQuestionBankData] = useState({
    questionBankId: "",
    questionBankTeacherId: "",
    questionBankName: "",
  });
  const [questionBankRenameData, setQuestionBankRenameData] = useState({
    questionBankName: "",
    questionBankId: "",
    questionBankSection: "",
    questionBankStandard: "",
  });
  const [filter, setFilter] = useState({
    standard_id: "",
    section_id: "",
    standardName: "",
    sectionName: "",
    subject_id: "",
    book: "",
    chapter: "",
    skill: "",
    difficulty_level: "",
    question_type: "",
    subjectId: [],
    date: "",
    time: "",
    searchvalue: "",
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  const togglePopup = () => {
    setIsPopupOpen((prev) => !prev);
  };

  useEffect(() => {
    if (
      type == "MY_QUESTION_BANK" &&
      filter.standardName === null &&
      filter.standard_id === null
    ) {
      setFilter({
        ...filter,
        section_id: "",
        sectionName: "",
        standard_id: "",
        standardName: "",
        subject_id: "",
      });
    }
  }, [filter.standardName]);

  let tempSectionArr = [];
  // let standardArr = [];
  const [standardArr, setStandardArr] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  let uniqueStandardSectionIds = [];
  function addUniqueObjectToArraystand(obj) {
    if (
      !standardArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
    ) {
      standardArr.push(obj);
    }
  }

  const handleSectionStandard = () => {
    if (generalRole_JSON !== null) {
      generalRole_JSON.forEach((item) => {
        const standardId = item.standard_id.id;
        const standardName = item.standard_id.name;
        const sectionId = item.section_id.id;
        const sectionName = item.section_id.name;
        const standardSectionObj = {
          standardId,
          standardName,
          sectionId,
          sectionName,
        };
        const isDuplicate = uniqueStandardSectionIds.some((item) => {
          return item.standardId === standardId && item.sectionId === sectionId;
        });
        if (!isDuplicate) {
          uniqueStandardSectionIds.push(standardSectionObj);
        }
      });
    }

    if (classTeacher_JSON !== null) {
      classTeacher_JSON.forEach((item) => {
        const standardId = item.standard_id.id;
        const standardName = item.standard_id.name;
        const sectionId = item.section_id.id;
        const sectionName = item.section_id.name;
        const standardSectionObj = {
          standardId,
          standardName,
          sectionId,
          sectionName,
        };

        const isDuplicate = uniqueStandardSectionIds.some((item) => {
          return item.standardId === standardId && item.sectionId === sectionId;
        });

        if (!isDuplicate) {
          uniqueStandardSectionIds.push(standardSectionObj);
        }
      });
    }

    if (cordinator_JSON !== null) {
      cordinator_JSON.forEach((item) => {
        const standardId = item.standard_id.id;
        const standardName = item.standard_id.name;
        const sectionId = item.section_id.id;
        const sectionName = item.section_id.name;
        const standardSectionObj = {
          standardId,
          standardName,
          sectionId,
          sectionName,
        };

        const isDuplicate = uniqueStandardSectionIds.some((item) => {
          return item.standardId === standardId && item.sectionId === sectionId;
        });

        if (!isDuplicate) {
          uniqueStandardSectionIds.push(standardSectionObj);
        }
      });
    }
  };

  const dropDownHelper = () => {
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
    setStandardArr([...standardArr]);
  };

  function addUniqueObjectToArraysect(obj) {
    if (
      !tempSectionArr.some(
        (item) => JSON.stringify(item) === JSON.stringify(obj),
      )
    ) {
      tempSectionArr.push(obj);
    }
  }
  const handleDropDownSec = () => {
    const selectedStandardId = filter.standard_id;
    tempSectionArr = [];
    generalRole_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    setSectionArr([...tempSectionArr]);
  };

  useEffect(() => {
    setSectionArr([]);
    handleDropDownSec();
  }, [filter.standard_id]);

  const dateHelper = (a) => {
    const inputDate = new Date(a);
    const month = inputDate.getMonth() + 1;
    const day = inputDate.getDate();
    const year = inputDate.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const getBookAndChapter = async () => {
    try {
      setBook([]);
      setBookAndChapter([]);
      setChapter([]);
      setFilter((prev) => {
        return {
          ...prev,
          book: "",
          chapter: "",
        };
      });
      let res = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${filter.standard_id}&section_id=${filter.section_id}&subject_id=${filter.subject_id}&timetableSessionId=${timeTableSessionId}`,
      );

      if (res.status === 200 && res.data.data.length > 0) {
        setBook(res.data.data[0].bookInfo);
        let bookChapterObj = {};
        res.data.data[0].bookInfo.map((book) => {
          bookChapterObj[book.id] = book;
        });
        setBookAndChapter(bookChapterObj);
      } else {
        toast.error("Book not found");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const normalizeQuestionBankData = (data = []) => {
    return data.map((item) => ({
      id: item.id,
      name: item.name,

      // fallback values so UI na toote
      standard_id: item.standard_id || {
        id: filter.standard_id,
        name: filter.standardName || "",
      },

      section_id: item.section_id || {
        id: filter.section_id,
        name: filter.sectionName || "",
      },

      subject_id: item.subject_id || {
        id: filter.subject_id,
        name: subjects.find((s) => s.id === filter.subject_id)?.name || "",
      },

      updated_at: item.updated_at || new Date().toISOString(),
    }));
  };

  const getMyQuestionBank = async () => {
    try {
      setIsGettingData(true);

      // ✅ CASE 1: subject_id SELECTED → NEW API
      if (
        filter.subject_id &&
        filter.subject_id !== "" &&
        filter.subject_id !== "null"
      ) {
        const params = {
          standard_id: filter.standard_id,
          section_id: filter.section_id,
          subject_id: filter.subject_id,
        };

        const res = await axios.get("/api/v1/questionBank/getBySubjectId", {
          params,
        });

        const normalizedData = normalizeQuestionBankData(res.data.data);

        setQuesData(normalizedData);
        return;
      }

      const params = {
        teacher_id: TeacherId,
      };

      // ===== BASIC FILTERS =====
      if (filter.standard_id) params.standard_id = filter.standard_id;
      if (filter.section_id) params.section_id = filter.section_id;

      // ===== DATE / TIME =====
      if (choosedDate?.length) params.date = choosedDate[0];
      if (filter.time) params.time = filter.time;

      // ===== MULTI SUBJECT (if any) =====
      if (filter.subjectId?.length) {
        params.subjectId = filter.subjectId.join(",");
      }

      // ===== ADVANCED FILTERS =====
      if (filter.skill) params.skillId = filter.skill;
      if (filter.difficulty_level)
        params.difficultyLevelId = filter.difficulty_level;
      if (filter.question_type) params.questionTypeId = filter.question_type;

      // ===== SEARCH =====
      if (filter.searchvalue) params.search = filter.searchvalue;

      // ===== OPTIONAL =====
      if (filter.book) params.bookId = filter.book;
      if (filter.chapter) params.chapterId = filter.chapter;

      const res = await axios.get("/api/v1/questionbank/get", {
        params,
      });

      setQuesData(res.data.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsGettingData(false);
    }
  };

  console.log(quesData, "quesData");

  useEffect(() => {
    if (type === "MY_QUESTION_BANK" && TeacherId) {
      getMyQuestionBank();
    }
  }, [
    filter.standard_id,
    filter.section_id,
    filter.subject_id,
    filter.subjectId,
    filter.skill,
    filter.difficulty_level,
    filter.question_type,
    filter.searchvalue,
    filter.time,
    filter.book,
    filter.chapter,
    choosedDate,
    TeacherId,
  ]);

  const getB4SQuestionBank = async () => {
    try {
      setB4sQuesData([]);
      setIsGettingB4SData(true);
      // b4sQuestion/filter?_page=1&_limit=9&standardId=665080ec065d14705f080823&sectionId=665080ec065d14705f080832&subjectId=665080ec065d14705f08082e&bookId=661e9714755e7e3f5b9f3d00&chapterId=661e96cd755e7e3f5b9f3cfe&domainId=66196ba96be21a6b6775f836&skillId=661eba66755e7e3f5b9f3d28&difficultyLevelId=652ebaf6721c0955abdf05b1
      let queryParams = {
        standardId: filter.standard_id,
        sectionId: filter.section_id,
        subjectId: filter.subject_id,
        bookId: filter.book,
        chapterId: filter.chapter,
        skillId: filter.skill,
        difficultyLevelId: filter.difficulty_level,
        typeId: filter.question_type,
      };
      let res = await axios.get(`/api/v1/b4sQuestion/filter`, {
        params: queryParams,
      });
      setB4sQuesData(res.data.data);
      setIsGettingB4SData(false);
    } catch (error) {
      console.log(error);
    }
    setIsGettingB4SData(false);
  };

  useEffect(() => {
    if (TeacherId == null) {
      setTeacherId(JSON.parse(localStorage.getItem("Teacher_id")));
    }
    handleSectionStandard();
    dropDownHelper();
    handleDropDownSec();
  }, []);

  useEffect(() => {
    if (type == "MY_QUESTION_BANK") {
      if (TeacherId == null) {
        let teacherIdData = JSON.parse(localStorage.getItem("Teacher_id"));
        setTeacherId(teacherIdData);
      }
      if (TeacherId !== null) {
        getMyQuestionBank();
      }
    } else {
      if (
        filter.standard_id !== "" &&
        filter.subject_id !== "" &&
        filter.book !== "" &&
        filter.chapter !== ""
      ) {
        console.log("api called");
        getB4SQuestionBank();
      }
    }
  }, [filter, choosedDate, TeacherId]);

  useEffect(() => {
    if (
      type === "B4S_QUESTION_BANK" &&
      filter.standard_id !== "" &&
      filter.subject_id !== "" &&
      filter.section_id !== ""
    ) {
      getBookAndChapter();
    }
  }, [filter.standard_id, filter.subject_id, filter.section_id]);

  useEffect(() => {
    if (filter.book !== "") {
      setChapter(bookAndChapter[filter.book].chapterData);
    }
  }, [filter.book]);

  const handleDeleteQuestionBank = async (questionBankId) => {
    try {
      if (questionBankId !== deleteQuestionBankData.questionBankId) {
        toast.error("Question Bank Id is not matching");
        return false;
      }
      let data = {
        teacher_id: deleteQuestionBankData.questionBankTeacherId,
      };
      setIsProcessLoading(true);
      let res = await axios.delete(
        `/api/v1/questionBank/delete/${questionBankId}`,
        { data },
      );
      toast.success(res.data.message);
      setOpenDeleteQuestionBankConfirmationPopup(false);
      getMyQuestionBank();
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    }
    setIsProcessLoading(false);
  };

  const handleRenameQuestionBankName = async (questionBankId) => {
    try {
      if (questionBankId !== questionBankRenameData.questionBankId) {
        toast.error("Question Bank Id is not matching");
        return false;
      }
      let data = {
        standard_id: questionBankRenameData.questionBankStandard,
        section_id: questionBankRenameData.questionBankSection,
        name: questionBankRenameData.questionBankName,
      };
      setIsProcessLoading(true);
      let res = await axios.put(
        `/api/v1/questionBank/updateName/questionbankId/${questionBankId}`,
        data,
      );
      toast.success(res.data.message);
      setOpenRenameQuestionBankNamePopup(false);
      getMyQuestionBank();
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    }
    setIsProcessLoading(false);
  };

  const isClassTeacherOrCoordinator = (standardId, sectionId) => {
    const isCT = classTeacher_JSON?.some(
      (r) =>
        r.standard_id?.id === standardId &&
        r.section_id?.id === sectionId &&
        r.is_class_teacher === true,
    );

    const isCO = cordinator_JSON?.some(
      (r) => r.standard_id?.id === standardId && r.section_id?.id === sectionId,
    );

    return isCT || isCO;
  };

  const getAllSubjectsFromAPI = async (standardId, sectionId) => {
    try {
      const res = await axios.get(
        `/api/v1/school/standardId/${standardId}/sectionId/${sectionId}/getSubjects`,
      );
      const data = res?.data?.data;
      const subjectSource =
        data?.subjectConfigurations?.length > 0
          ? data.subjectConfigurations.map((item) => item.subject)
          : data.subjects;
      return subjectSource || [];
    } catch (err) {
      console.error("Subject API failed", err);
      return [];
    }
  };

  const getSubjectsFromLocalRoles = (standardId, sectionId) => {
    const map = new Map();

    generalRole_JSON?.forEach((role) => {
      if (
        role?.standard_id?.id === standardId &&
        role?.section_id?.id === sectionId
      ) {
        role.subjects_id?.forEach((sub) => {
          if (sub?.id && !map.has(sub.id)) {
            map.set(sub.id, {
              id: sub.id,
              name: sub.name,
            });
          }
        });
      }
    });

    return Array.from(map.values());
  };

  useEffect(() => {
    const loadSubjects = async () => {
      if (!filter.standard_id || !filter.section_id) {
        setSubjects([]);
        return;
      }

      const standardId = filter.standard_id;
      const sectionId = filter.section_id;

      const isPrivileged = isClassTeacherOrCoordinator(standardId, sectionId);

      // ✅ CASE 1: Class Teacher / Coordinator → ALL subjects from API
      if (isPrivileged) {
        const allSubjects = await getAllSubjectsFromAPI(standardId, sectionId);
        setSubjects(allSubjects);
        return;
      }

      // ✅ CASE 2: General Teacher → Filtered subjects
      const apiSubjects = await getAllSubjectsFromAPI(standardId, sectionId);

      const allowedSubjects = getSubjectsFromLocalRoles(standardId, sectionId);

      const allowedIds = new Set(allowedSubjects.map((s) => s.id));

      const finalSubjects = apiSubjects.filter((s) => allowedIds.has(s.id));

      setSubjects(finalSubjects);
    };

    loadSubjects();
  }, [filter.standard_id, filter.section_id]);

  const [b4sQustionId, setB4SQuestionId] = useState(null);
  const [myQuestionId, setMyQuestionId] = useState(null);

  const filteredMyQuestionBank = quesData
    ?.filter((obj) => {
      if (!searchText.trim()) return true;
      const query = searchText.toLowerCase();
      return (
        obj?.name?.toLowerCase().includes(query) ||
        obj?.subject_id?.name?.toLowerCase().includes(query) ||
        obj?.standard_id?.name?.toLowerCase().includes(query) ||
        obj?.section_id?.name?.toLowerCase().includes(query)
      );
    })
    // 👈 NEW: Sort by updated_at descending (newest first)
    ?.sort((a, b) => {
      const dateA = new Date(a.updated_at || a.created_at || 0).getTime();
      const dateB = new Date(b.updated_at || b.created_at || 0).getTime();
      return dateB - dateA;
    });

  const reduceParaGraph = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.substring(0, length) + "...";
  };

  const handleClearAll = () => {
    setSearchText("");
    setSelectedDate([]);
    setChoosedDate([]);

    setFilter({
      standard_id: "",
      section_id: "",
      standardName: "",
      sectionName: "",
      subject_id: "",
      book: "",
      chapter: "",
      skill: "",
      difficulty_level: "",
      question_type: "",
    });
  };

  return (
    <div>
      {type === "MY_QUESTION_BANK" ? (
        <div className="d-flex  gap-3  justify-content-end">
          {activeHeader === "QuestionBank" && (
            <div className="gap-4 d-flex mt-2 mt-md-0">
              <div
                onClick={(e) => {
                  checkLocalData();
                }}
                className=" col-md-2 gap-2 Create_bnt_CM"
              >
                <img src="/ContentM_images/add icon.svg" alt="add logo" />
                <span>Create</span>
              </div>
            </div>
          )}
          <div className="col-10 p-0 d-flex justify-content-around align-items-center tabView">
            {/* Date Picker */}
            <input
              type="text"
              placeholder="Search by name..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="form-control"
              style={{
                width: "220px",
                height: "40px",
                borderRadius: "10px",
                border: "1px solid #ccc",
              }}
            />
            <div
              className=" datePicker dateSecStdWidth"
              style={{ borderColor: "#668598", height: "40.6px" }}
            >
              <DatePickerComponent
                style={{ width: "160px" }}
                className="customColor"
                disabled={filter.subject_id}
                allowEdit={false}
                value={selectedDate[0]}
                id="datepickerLive"
                placeholder="Date"
                onChange={(e) => {
                  // e.value will be the selected date (null if cleared)
                  if (e.value !== null) {
                    setChoosedDate([dateHelper(e.value)]); // Convert the date to an array
                  } else {
                    // Date cleared using the cross icon, set state to an empty array
                    setChoosedDate([]);
                  }
                }}
                onClose={(e) => {
                  if (e.value !== null) {
                    setChoosedDate([dateHelper(e.value)]); // Convert the date to an array
                  }
                }}
              />
            </div>

            {/* Class Select */}
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel>Select Class</InputLabel>
              <Select
                label="Select Class"
                id="Live_dropdown_CM"
                value={filter.standard_id || ""}
                onChange={(e) => {
                  const selectedStandardId = e.target.value;
                  const selectedStandard = standardArr.find(
                    (obj) => obj.id === selectedStandardId,
                  );

                  setFilter({
                    ...filter,
                    standard_id: selectedStandardId,
                    standardName: selectedStandard?.name || null,
                    section_id: "", // class badalne par section reset
                    sectionName: null,
                  });
                }}
              >
                <MenuItem value="">Select All</MenuItem>
                {standardArr?.length > 0 &&
                  [...standardArr]
                    .sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);

                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) {
                        return aNum - bNum; // numeric sort
                      }

                      return a.name.localeCompare(b.name); // alphabetical sort
                    })
                    .map((standard, index) => (
                      <MenuItem
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>

            {/* Section Select */}
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel>Select Section</InputLabel>
              <Select
                label="Select Section"
                id="Live_dropdown_CM"
                value={filter.section_id || ""}
                onChange={(e) => {
                  const selectedSectionId = e.target.value;
                  const selectedSection = sectionArr.find(
                    (obj) => obj.id === selectedSectionId,
                  );

                  setFilter({
                    ...filter,
                    section_id: selectedSectionId,
                    sectionName: selectedSection?.name || null,
                  });
                }}
              >
                <MenuItem value="">Select All</MenuItem>
                {sectionArr.map((obj) => (
                  <MenuItem key={obj.id} value={obj.id}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel>Select Subject</InputLabel>
              <Select
                label="Select Subject"
                disabled={!filter.standard_id || !filter.section_id}
                value={filter.subject_id || ""}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  setFilter((prev) => ({ ...prev, subject_id: selectedId }));
                }}
              >
                <MenuItem value="">Select Subject</MenuItem>
                {subjects.map((obj) => (
                  <MenuItem key={obj.id} value={obj.id}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="outlined"
              onClick={handleClearAll}
              disabled={
                !searchText &&
                !filter.standard_id &&
                !filter.section_id &&
                !choosedDate.length
              }
              sx={{
                height: "40px",
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
                borderColor: "#ff9800",
                color: "#ff9800",
                "&:hover": {
                  backgroundColor: "#fff3e0",
                  borderColor: "#fb8c00",
                },
              }}
            >
              Clear All
            </Button>
          </div>
        </div>
      ) : (
        <div className="d-flex  gap-3 justify-content-end">
          <div className="col-12 p-0 d-flex justify-content-around tabView">
            {/* Class & Section */}
            <div className="col-sm-3 d-flex gap-1 flex-wrap">
              {/* Class Select */}
              <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
                <InputLabel>Select Class*</InputLabel>
                <Select
                  label="Select Class*"
                  value={filter.standard_id || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selected = standardArr.find(
                      (obj) => obj.id === selectedId,
                    );
                    setFilter((prev) => ({
                      ...prev,
                      standard_id: selectedId,
                      standardName: selected?.name || "",
                      section_id: "", // Reset section on class change
                      sectionName: "",
                    }));
                  }}
                >
                  <MenuItem value="">Select All</MenuItem>
                  {standardArr?.length > 0 &&
                    [...standardArr]
                      .sort((a, b) => {
                        const aNum = Number(a.name);
                        const bNum = Number(b.name);

                        const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                        if (bothNumeric) {
                          return aNum - bNum; // numeric sort
                        }

                        return a.name.localeCompare(b.name); // alphabetical sort
                      })
                      .map((standard, index) => (
                        <MenuItem
                          key={index}
                          value={standard?.id}
                          name={standard?.name}
                        >
                          {standard?.name}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>

              {/* Section Select */}
              <FormControl
                size="small"
                fullWidth
                sx={{ minWidth: 150 }}
                disabled={!filter.standard_id}
              >
                <InputLabel>Select Section*</InputLabel>
                <Select
                  label="Select Section*"
                  value={filter.section_id || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selected = sectionArr.find(
                      (obj) => obj.id === selectedId,
                    );
                    setFilter((prev) => ({
                      ...prev,
                      section_id: selectedId,
                      sectionName: selected?.name || "",
                    }));
                  }}
                >
                  <MenuItem value="">Select All</MenuItem>
                  {sectionArr.map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Subject, Book, Chapter, Skill, Difficulty, Question Type */}
            <div className="d-flex col-sm-8 gap-3 flex-wrap">
              {/* Subject Select */}
              <FormControl size="small" sx={{ width: "30%" }}>
                <InputLabel>Select Subject*</InputLabel>
                <Select
                  label="Select Subject*"
                  value={filter.subject_id || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setFilter((prev) => ({ ...prev, subject_id: selectedId }));
                  }}
                >
                  <MenuItem value="">Select Subject*</MenuItem>
                  {subjects.map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Book Select */}
              <FormControl size="small" sx={{ width: "30%" }}>
                <InputLabel>Select Book*</InputLabel>
                <Select
                  label="Select Book*"
                  value={filter.book || ""}
                  onChange={(e) => {
                    setFilter((prev) => ({ ...prev, book: e.target.value }));
                  }}
                >
                  <MenuItem value="">Select Book*</MenuItem>
                  {book.map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Chapter Select */}
              <FormControl size="small" sx={{ width: "35%" }}>
                <InputLabel>Select Chapter*</InputLabel>
                <Select
                  label="Select Chapter*"
                  value={filter.chapter || ""}
                  onChange={(e) => {
                    setFilter((prev) => ({ ...prev, chapter: e.target.value }));
                  }}
                >
                  <MenuItem value="">Select Chapter*</MenuItem>
                  {chapter.map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.chapterName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Skill Select */}
              <FormControl size="small" sx={{ width: "30%" }}>
                <InputLabel>Select Skill</InputLabel>
                <Select
                  label="Select Skill"
                  value={filter.skill || ""}
                  onChange={(e) => {
                    setFilter((prev) => ({ ...prev, skill: e.target.value }));
                  }}
                >
                  <MenuItem value="">Select Skill</MenuItem>
                  {skills.map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Difficulty Level Select */}
              <FormControl size="small" sx={{ width: "30%" }}>
                <InputLabel>Select Difficulty Level</InputLabel>
                <Select
                  label="Select Difficulty Level"
                  value={filter.difficulty_level || ""}
                  onChange={(e) => {
                    setFilter((prev) => ({
                      ...prev,
                      difficulty_level: e.target.value,
                    }));
                  }}
                >
                  <MenuItem value="">Select Difficulty Level</MenuItem>
                  {difficultyLevel.map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Question Type Select */}
              <FormControl size="small" sx={{ width: "35%" }}>
                <InputLabel>Select Question Type</InputLabel>
                <Select
                  label="Select Question Type"
                  value={filter.question_type || ""}
                  onChange={(e) => {
                    setFilter((prev) => ({
                      ...prev,
                      question_type: e.target.value,
                    }));
                  }}
                >
                  <MenuItem value="">Select Question Type</MenuItem>
                  <MenuItem value="66d5c0c219a9ee1c2767e323">MCQ</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      )}
      <div className="d-flex justify-content-between m-2 mt-4">
        <div className="QuestionBankHeading">
          {type === "MY_QUESTION_BANK"
            ? "My Question Bank"
            : "B4S Question Bank"}
        </div>
      </div>
      <div
        className="d-flex ml-4 gap-2 flex-wrap mt-2 orange-scrollBar"
        style={{ maxHeight: "calc(100vh - 330px)", overflowY: "auto" }}
      >
        {type === "B4S_QUESTION_BANK" ? (
          b4sQuesData?.length > 0 ? (
            <div className="container">
              <div className="row">
                {" "}
                {b4sQuesData?.map((obj) => (
                  <div
                    key={obj.id}
                    className="col-md-3 d-flex mb-3"
                    onClick={() => setB4SQuestionId(obj.id)}
                  >
                    <div
                      className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
                      style={{
                        backgroundColor: "#FDEFE3",
                        borderTop: "2px solid #8D4B28",
                        borderRight: "4px solid #8D4B28",
                        borderBottom: "1px solid #8D4B28",
                        borderLeft: "1px solid #8D4B28",
                        borderRadius: "0.75rem",
                        cursor: "pointer",
                      }}
                    >
                      {/* Title */}
                      <div
                        className="align-items-center text-dark d-flex gap-2"
                        style={{ minHeight: "48px" }} // set consistent height
                      >
                        {/* Icon aligned to top */}
                        <div style={{ flexShrink: 0 }}>
                          <Lightbulb size={20} color="#000" />
                        </div>

                        {/* Text (2-line ellipsis with fixed height) */}
                        <Tooltip
                          title={obj?.title}
                          arrow
                          placement="top"
                          enterDelay={200}
                          leaveDelay={100}
                        >
                          <div
                            className="text-truncate poppins-semibold"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              lineHeight: "1.3em",
                              height: "2.6em", // ensures 2-line space
                              paddingTop: "11px",
                            }}
                          >
                            {obj?.title}
                          </div>
                        </Tooltip>
                      </div>

                      {/* Line 1: Domain | Skill | Type */}
                      <div className="mb-1  gap-2  small d-flex align-items-center poppins-semibold">
                        <ClipboardList
                          size={20}
                          color="#000"
                          className="me-1"
                        />{" "}
                        {obj?.skill?.name} | {obj?.difficulty_level?.name} |{" "}
                        {obj?.type?.name}
                      </div>

                      {/* Line 2: Difficulty | Book : Chapter */}
                      <div
                        className="d-flex gap-2 poppins-semibold text-dark"
                        style={{ minHeight: "48px", alignItems: "flex-start" }}
                      >
                        {/* Top-aligned icon */}
                        <div style={{ flexShrink: 0, paddingTop: "2px" }}>
                          <BookOpen size={20} color="#000" />
                        </div>

                        {/* 2-line ellipsis text */}
                        <div
                          className="small poppins-semibold"
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: "1.3em",
                            height: "2.6em", // ensures 2-line space
                          }}
                        >
                          {obj?.book?.name} : {obj?.chapter?.chapterName}
                        </div>
                      </div>

                      {/* Footer: Date + Checkbox */}
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <CalendarDays size={20} color="#000" />{" "}
                          {/* Calendar */}
                          <div className=" small">
                            {obj?.created_at && (
                              <small className="poppins-semibold">
                                {convertDateTime(obj.updated_at)}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      {obj?.attachments.length > 0 ? (
                        <span>
                          <img
                            src="/images/photo-1909.png"
                            alt="img"
                            className="attachImg"
                          />{" "}
                        </span>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : isGettingB4SData ? (
            <img
              className="ongoing_loader"
              src="/gif/LoaderDot.gif"
              alt="b4s question bank loader"
            />
          ) : filter.standard_id !== "" &&
            filter.subject_id !== "" &&
            filter.book !== "" &&
            filter.chapter !== "" ? (
            <Alert
              icon={<InfoIcon fontSize="inherit" />}
              severity="info"
              sx={{
                backgroundColor: "#E3F2FD",
                color: "#1565C0",
                fontWeight: 500,
                mt: 2,
                borderRadius: 2,
              }}
            >
              B4S QuestionBank Not Found
            </Alert>
          ) : (
            <Alert
              icon={<InfoIcon fontSize="inherit" />}
              severity="warning"
              sx={{
                backgroundColor: "#FFF4E5",
                color: "#F77F00",
                fontWeight: 500,
                mt: 2,
                borderRadius: 2,
              }}
            >
              Please select above fields to get <b> B4S Question Bank. </b>
            </Alert>
          )
        ) : null}
        {type === "MY_QUESTION_BANK" ? (
          filteredMyQuestionBank?.length > 0 ? (
            <div className="container">
              <div className="row">
                {filteredMyQuestionBank?.map((obj) => {
                  return (
                    <div key={obj.id} className="col-md-3 d-flex mb-3">
                      <div
                        className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
                        style={{
                          backgroundColor: "#FDEFE3",
                          borderTop: "2px solid #8D4B28",
                          borderRight: "4px solid #8D4B28",
                          borderBottom: "1px solid #8D4B28",
                          borderLeft: "1px solid #8D4B28",
                          borderRadius: "0.75rem",
                          cursor: "pointer",
                        }}
                      >
                        {/* Header: Class | Section | Subject + 3 dots */}
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <NavLink
                            to="/qBankDetails"
                            className="text-dark fw-semibold text-decoration-none"
                            state={{ qsbid: obj.id }}
                          >
                            <div className="d-flex flex-wrap align-items-center gap-1 poppins-semibold">
                              <span>{`${obj?.standard_id?.name || ""} - ${obj?.section_id?.name || ""} | `}</span>
                              <span title={obj?.subject_id?.name || ""}>
                                {reduceParaGraph(obj?.subject_id?.name, 27) ||
                                  ""}
                              </span>
                            </div>
                          </NavLink>

                          <Popup
                            trigger={
                              <img
                                src="/images/menu-dots-vertical 1.svg"
                                className="hw_card_three_dot"
                                alt=""
                              />
                            }
                            content={
                              <div className="hw_popup_box_size px-2">
                                <ThreeDotPopup
                                  questionBankObj={obj}
                                  setOpenRenameQuestionBankNamePopup={
                                    setOpenRenameQuestionBankNamePopup
                                  }
                                  setQuestionBankRenameData={
                                    setQuestionBankRenameData
                                  }
                                  setDeleteQuestionBankData={
                                    setDeleteQuestionBankData
                                  }
                                  setOpenDeleteQuestionBankConfirmationPopup={
                                    setOpenDeleteQuestionBankConfirmationPopup
                                  }
                                />
                              </div>
                            }
                            on="click"
                            hideOnScroll
                            position="bottom right"
                          />
                        </div>

                        {/* Question Bank Name */}
                        <NavLink
                          to="/qBankDetails"
                          className="text-dark text-decoration-none"
                          state={{ qsbid: obj.id }}
                        >
                          <div className="d-flex align-items-center mb-1">
                            <BookText size={16} className="me-2 text-dark" />
                            <div className="text-truncate poppins-semibold">
                              {reduceParaGraph(obj?.name, 25) || "No Name"}
                            </div>
                          </div>

                          {/* Updated On Date */}
                          <div
                            className="d-flex align-items-center text-muted"
                            style={{ fontSize: "0.875rem" }}
                          >
                            <CalendarDays
                              size={16}
                              className="me-2 text-dark"
                            />
                            <span>
                              <span className="me-1">Updated On:</span>
                              <span className="text-dark">
                                {obj?.updated_at
                                  ? convertDateTime(obj.updated_at)
                                  : ""}
                              </span>
                            </span>
                          </div>
                        </NavLink>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : isGettingData ? (
            <img
              className="ongoing_loader"
              src="/gif/LoaderDot.gif"
              alt="my question bank loader"
            />
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: "260px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  background: "#fff7ed",
                  border: "1px dashed #fb923c",
                  borderRadius: "16px",
                  padding: "32px 40px",
                  maxWidth: "420px",
                }}
              >
                <InfoIcon sx={{ fontSize: 48, color: "#fb923c", mb: 1 }} />

                <h5
                  style={{
                    margin: "12px 0 6px",
                    fontWeight: 700,
                    color: "#7c2d12",
                  }}
                >
                  No Question Bank Found
                </h5>

                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#92400e",
                  }}
                >
                  Try changing filters, clearing search,
                  <br />
                  or create a new Question Bank.
                </p>
              </div>
            </div>
          )
        ) : null}
      </div>

      {openDeleteQuestionBankConfirmationPopup ? (
        <DeleteConfirmationPopup
          setOpenDeleteQuestionBankConfirmationPopup={
            setOpenDeleteQuestionBankConfirmationPopup
          }
          deleteQuestionBankData={deleteQuestionBankData}
          handleDeleteQuestionBank={handleDeleteQuestionBank}
          isProcessLoading={isProcessLoading}
        />
      ) : null}
      {openRenameQuestionBankNamePopup ? (
        <ChangeNamePopup
          setOpenRenameQuestionBankNamePopup={
            setOpenRenameQuestionBankNamePopup
          }
          questionBankRenameData={questionBankRenameData}
          setQuestionBankRenameData={setQuestionBankRenameData}
          handleRenameQuestionBankName={handleRenameQuestionBankName}
          isProcessLoading={isProcessLoading}
        />
      ) : null}
      {(b4sQustionId || myQuestionId) && (
        <QuestionPopup
          b4sid={b4sQustionId}
          setB4SQuestionId={setB4SQuestionId}
          qId={myQuestionId}
          setQuestion={setMyQuestionId}
        />
      )}
    </div>
  );
}
